// extracted by mini-css-extract-plugin
export default {"backbutton":"Login_backbutton__eaj6Q","loginform":"Login_loginform__daKaX","loginContainer":"Login_loginContainer__YTf78","loginWraper":"Login_loginWraper__jhf38"};